import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// import { useRouter } from 'next/router';

export default function Popup({
  showPopup, messageData, popupFor, onPopupClose, batchHeading, divwidth, title, btnTitle, submitTest, subHeading,
}) {
  // Handle Escape key to close popup
  useEffect(() => {
    if (!showPopup) return undefined;

    const handleEscapeKey = (e) => {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        e.stopImmediatePropagation();
        onPopupClose();
      }
    };

    // Use capture phase to intercept before other handlers
    window.addEventListener('keydown', handleEscapeKey, true);

    return () => {
      window.removeEventListener('keydown', handleEscapeKey, true);
    };
  }, [showPopup, onPopupClose]);

  if (!showPopup) return null; // Return nothing if the popup is not visible
  // const router = useRouter();

  const handleSubmit = () => {
    submitTest(true);
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-[1000]" onClick={onPopupClose}>

      <div className={`overflow-y-scroll fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white text-black p-5 rounded-lg z-[9999] text-center max-w-[95%] max-h-[90vh] ${divwidth}`} onClick={(e) => e.stopPropagation()}>
        {
          (popupFor === 'MyCourse' || popupFor === 'Instructions' || popupFor === 'QuestionPaper') && (
            // eslint-disable-next-line jsx-a11y/control-has-associated-label
            <button
              type="button"
              className={`${btnTitle ? 'hidden' : ''} absolute top-3 right-3 text-sm ${(popupFor === 'Instructions' || popupFor === 'QuestionPaper') ? 'z-10 text-white flex items-center' : 'text-[#0F172A]'} `}
              onClick={onPopupClose}
            >
              <span className={`${(popupFor === 'Instructions' || popupFor === 'QuestionPaper') ? 'block pr-2 text-xs' : 'hidden'}`}>Close</span>
              <svg className={`${(popupFor === 'Instructions' || popupFor === 'QuestionPaper') ? 'w-[10px] h-[10px]' : 'w-[14px] h-[14px]'}`} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.47635 7.24351L13.8632 1.85671C14.1756 1.54431 14.1756 1.03791 13.8632 0.725511C13.5512 0.413111 13.044 0.413111 12.732 0.725511L7.34515 6.11231L1.95915 0.725511C1.64715 0.413111 1.14035 0.413111 0.827951 0.725511C0.515551 1.03791 0.515551 1.54431 0.827951 1.85671L6.21395 7.24351L0.496751 12.9607C0.184351 13.2731 0.184351 13.7795 0.496751 14.0919C0.652751 14.2483 0.85755 14.3263 1.06235 14.3263C1.26715 14.3263 1.47195 14.2483 1.62795 14.0919L7.34515 8.37471L13.0624 14.0919C13.2188 14.2483 13.4232 14.3263 13.628 14.3263C13.8328 14.3263 14.0372 14.2483 14.1936 14.0919C14.506 13.7795 14.506 13.2731 14.1936 12.9607L8.47635 7.24351Z" fill={`${popupFor === 'Instructions' || popupFor === 'QuestionPaper' ? '#fff' : '#0F172A'}`} />
              </svg>

            </button>
          )
        }
        {(batchHeading || subHeading) && (
          <div className="border-b border-b-[#D4EEFD] lg:mb-7 mb-6 text-[#0F172A] font-semibold lg:text-xl text-xl text-left lg:pb-5 pb-[7px]">
            {batchHeading}
            {subHeading && <div className="text-lg font-normal mt-1 text-[#0F172A]">{subHeading}</div>}
          </div>
        )}
        {title && <h2 className={`${popupFor === 'QuestionPaper' ? 'bg-[#0267B1] text-white p-2' : 'my-2'} text-xl font-bold`}>{title}</h2>}
        {popupFor ? (
          <p className="!text-base  text-left">{messageData}</p>
        ) : (<p>{messageData}</p>)}
        {
          btnTitle
          // eslint-disable-next-line jsx-a11y/control-has-associated-label
          && <button type="button" onClick={handleSubmit} className="bg-customBlue rounded-md p-4 text-lg font-semibold text-white w-full mt-5">{btnTitle}</button>
        }

      </div>
    </div>
  );
}

Popup.propTypes = {
  showPopup: PropTypes.any.isRequired,
  messageData: PropTypes.any.isRequired,
  popupFor: PropTypes.any,
  onPopupClose: PropTypes.any,
  batchHeading: PropTypes.any,
  divwidth: PropTypes.any,
  title: PropTypes.string,
  btnTitle: PropTypes.string,
  // linkId: PropTypes.any,
  subHeading: PropTypes.any,
  submitTest: PropTypes.any,
};
